import { useEffect, useRef } from "react";

// Enter inside a list row never submits the form; on the LAST row it appends the next row instead.
export function enterAddsRow(isLast, add) {
  return (e) => {
    if (e.key !== "Enter") return;
    e.preventDefault();
    if (isLast) add();
  };
}

// After a row is appended, focus its first field (matched by `selector`) so entry continues keyboard-only.
export function useFocusNewRow(count, selector) {
  const ref = useRef(null);
  const prev = useRef(count);
  const armed = useRef(false);
  useEffect(() => {
    if (armed.current && count > prev.current && ref.current) {
      const el = ref.current.querySelector(selector(count - 1));
      if (el) requestAnimationFrame(() => el.focus());
    }
    armed.current = false;
    prev.current = count;
  }, [count, selector]);
  return { ref, arm: () => { armed.current = true; } };
}
